// reveal-on-scroll.js

document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  const elementsToObserve = document.querySelectorAll('.reveal');
  elementsToObserve.forEach(element => observer.observe(element));
});
